import { Retailer } from '../types';
import styles from './agreement.module.scss';

type AgreementProps = {
  retailer: Retailer;
};
const X5Agreement = () => {
  return <>
        <p>
          Я&nbsp;соглашаюсь с&nbsp;обработкой моих персональных данных (далее&nbsp;&mdash; ПДн) ООО
          &laquo;Агроторг&raquo;, адрес: 109029, г. Москва, ул. Средняя Калитниковская, д.&nbsp;28, стр.&nbsp;4;
          (далее&nbsp;&mdash; &laquo;<strong>Компания</strong>&raquo;), на&nbsp;условиях, установленных в&nbsp;настоящем
          согласии.
        </p>
      <p>
        <strong>Цель обработки персональных данных:</strong>
      </p>
      <p>
        оценка и&nbsp;рассмотрение моей кандидатуры (далее также&nbsp;&mdash; Соискатель) для замещения вакантной
        должности и&nbsp;принятия решения о&nbsp;трудоустройстве Соискателя в&nbsp;Компанию (включая проведение
        комплаенс-контроля и осуществление процесса противодействия коррупции, а&nbsp;также формирование кадрового
        резерва Оператора и&nbsp;группы Х5&nbsp;для замещения вакантных должностей).
      </p>
      <p>
        <strong>Категории обрабатываемых ПДн:</strong> для достижения указанной цели осуществляется обработка следующих
        ПДн:
      </p>
      <ul className={styles.list}>
        <li>
          ФИО (в&nbsp;том числе предыдущие фамилии, имена&nbsp;и (или) отчества, в&nbsp;случае их&nbsp;изменения),
          число, место и&nbsp;год рождения, место рождения, пол, информация о&nbsp;гражданстве, вид, серия, номер
          документа, удостоверяющего личность, наименование органа, выдавшего его, дата выдачи, адрес места жительства
          (адрес регистрации, фактического проживания);
        </li>
        <li>семейное положение, реквизиты свидетельства государственной регистрации актов гражданского состояния;</li>
        <li>
          состав семьи и&nbsp;сведения о&nbsp;близких родственниках (в&nbsp;том числе бывших), ФИО детей,
          их&nbsp;возраст и&nbsp;дата рождения, данные документа, удостоверяющего личность (данные паспорта: серия,
          номер, когда и&nbsp;каким органом выдан, код подразделения);
        </li>
        <li>адрес электронной почты, номер контактного телефона или сведения о других способах связи,</li>
        <li>сведения о&nbsp;воинском учете и&nbsp;реквизиты документов воинского учета,</li>
        <li>
          сведения об&nbsp;образовании, в&nbsp;том числе о&nbsp;послевузовском профессиональном образовании
          (наименование и&nbsp;год окончания образовательного учреждения, наименование и&nbsp;реквизиты документа
          об&nbsp;образовании, квалификация, специальность по&nbsp;документу об&nbsp;образовании), сведения
          об&nbsp;ученой степени,
        </li>
        <li>сведения об&nbsp;участии в&nbsp;учредительской/предпринимательской деятельности;</li>
        <li>сведения о&nbsp;наличии водительских прав;</li>
        <li>сведения о&nbsp;наличии личного автомобиля;</li>
        <li>сведения о&nbsp;трудовой деятельности;</li>
        <li>
          данные рабочей визы (серия и&nbsp;номер документа, фамилия, имя, национальность, дата выезда, дата окончания
          пребывания, количество дней пребывания, номер паспорта, дата рождения, пол, номер приглашения, цель поездки,
          принимающая организация, многократная/однократная), сведения, подтверждающие право нахождения
          на&nbsp;территории&nbsp;РФ, содержащиеся в&nbsp;виде на&nbsp;жительство/разрешении на временное
          проживание/визе/миграционной карте;
        </li>
        <li>
          сведения о&nbsp;предпринимательской деятельности (регистрация в&nbsp;качестве ИП / участника&nbsp;/
          единоличного исполнительного органа&nbsp;/ участника коллегиального органа, управляющего юридическим лицом)
        </li>
        <li>
          реквизиты страхового свидетельства государственного пенсионного страхования; идентификационный номер
          налогоплательщика; реквизиты страхового медицинского полиса обязательного медицинского страхования;
        </li>
        <li>владение иностранными языками;</li>
        <li>
          сведения, предоставленные Соискателем дополнительно (указанные в резюме, анкетах, в&nbsp;процессе
          собеседования).
        </li>
      </ul>
      <p>
        <strong>Перечень действий с&nbsp;ПДн:</strong> получение, сбор, запись, систематизация, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), блокирование,
        удаление, уничтожение.
      </p>
      <p>
        <strong>Способы обработки ПДн</strong>: обработка с&nbsp;использованием средств автоматизации и&nbsp;без
        использования средств автоматизации, а&nbsp;также смешанная обработка.
      </p>
      <p>Настоящим соглашаюсь на&nbsp;проверку предоставленных мной персональных данных и&nbsp;сведений.</p>
      <p>
        <strong>Лица, осуществляющие обработку по&nbsp;поручению</strong> для достижения указанной цели:
      </p>
      <ul className={styles.list}>
        <li>
          ООО &laquo;Скиллаз&raquo;, ОГРН: 1177746032276, адрес: 143026, г. Москва, территория Сколково Инновационного
          Центра, улица Нобеля, дом 5, этаж&nbsp;1, помещение&nbsp;1, рабочее место 11;
        </li>
        <li>
          ООО &laquo;ИТ&nbsp;ИКС 5&nbsp;Технологии&raquo;, расположенному по&nbsp;адресу: 420500, Респ. Татарстан,
          Верхнеуслонский р-н, г. Иннополис, ул. Университетская, д.&nbsp;7, офис 403;
        </li>
      </ul>
      <p>
        <strong>Третьи лица</strong>, которым Компания может передавать ПДн (предоставлять доступ к&nbsp;ним) для
        достижения указанной цели:
      </p>
      <ul className={styles.list}>
        <li>
          совокупность юридических лиц, входящих с&nbsp;ПАО &laquo;Корпоративный центр ИКС&nbsp;5&raquo; в&nbsp;одну
          группу лиц по&nbsp;смыслу&nbsp;ст.&nbsp;9&nbsp;Федерального закона от&nbsp;26.07.2006 &#8470;&nbsp;135-ФЗ
          &laquo;О&nbsp;защите конкуренции&raquo;, в&nbsp;том числе юридических лиц, функции единоличных исполнительных
          органов которых переданы ПАО &quot;Корпоративный центр ИКС&quot;5&Prime; по соответствующим договорам
          (далее&nbsp;&mdash; Группа Х5).
        </li>
      </ul>
      <p>
        <strong>Источники получения ПДн:</strong> Компания может получать ПДн от&nbsp;Соискателя; от&nbsp;лиц,
        осуществляющих обработку ПДн по&nbsp;поручению Компании (при наличии); от&nbsp;компаний Группы Х5, а&nbsp;также
        от&nbsp;государственных и&nbsp;муниципальных органов.
      </p>
      <p>
        <strong>Срок действия согласия:</strong> Согласие действует в&nbsp;течение
        <strong>5&nbsp;лет</strong>с момента последнего прохождения Соискателем собеседования в&nbsp;любом юридическом
        лице, входящем в&nbsp;Группу Х5.
      </p>
      <p>
        <strong>Отзыв согласия:</strong> Соискатель вправе отозвать настоящее согласие полностью или частично одним
        из&nbsp;следующих способов:
      </p>
      <ul className={styles.list}>
        <li>предоставив письменный отзыв согласия лично в&nbsp;Компанию;</li>
        <li>
          отправив сообщение на&nbsp;электронную почту{' '}
          <a className={styles.mailLink} href="mailto:pdn@x5.ru" target="_blank" rel="noopener noreferrer">
            pdn@x5.ru
          </a>{' '}
          с указанием в&nbsp;теме электронного письма &laquo;Отзыв согласия на&nbsp;обработку персональных данных&raquo;
          и&nbsp;прикреплением скан-копии подписанного заявления об отзыве согласия;
        </li>
        <li>
          направив письменный отзыв по&nbsp;адресу Компании: 109029, г. Москва, ул. Средняя Калитниковская, д.&nbsp;28,
          стр.&nbsp;4.
        </li>
      </ul>
      </>;
};

const ChizhikAgreement = () => {
  return (
    <>
      <p>
        Я&nbsp;соглашаюсь с&nbsp;обработкой моих персональных данных (далее&nbsp;&mdash; ПДн) АО &laquo;Продторг&raquo;,
        адрес: 109029, город Москва, Средняя Калитниковская ул, д.&nbsp;28, стр.&nbsp;4, этаж/пом/ком 1/XII/№36;
        (далее&nbsp;&mdash; &laquo;<strong>Компания</strong>&raquo;), на&nbsp;условиях, установленных в&nbsp;настоящем
        согласии.
      </p>

      <p>
        <strong>Цель обработки персональных данных:</strong>
      </p>
      <p>
        оценка и&nbsp;рассмотрение моей кандидатуры (далее также&nbsp;&mdash; Соискатель) для замещения вакантной
        должности и&nbsp;принятия решения о&nbsp;трудоустройстве Соискателя в&nbsp;Компанию (включая проведение
        комплаенс-контроля и осуществление процесса противодействия коррупции, а&nbsp;также формирование кадрового
        резерва Оператора и&nbsp;группы Х5&nbsp;для замещения вакантных должностей).
      </p>
      <p>
        <strong>Категории обрабатываемых ПДн:</strong> иные ПДн в составе:
      </p>
      <ul className={styles.list}>
        <li>
          ФИО (в&nbsp;том числе предыдущие фамилии, имена&nbsp;и (или) отчества, в&nbsp;случае их&nbsp;изменения),
          число, место и&nbsp;год рождения, место рождения, пол, информация о&nbsp;гражданстве, вид, серия, номер
          документа, удостоверяющего личность, наименование органа, выдавшего его, дата выдачи, адрес места жительства
          (адрес регистрации, фактического проживания);
        </li>
        <li>семейное положение, реквизиты свидетельства государственной регистрации актов гражданского состояния;</li>
        <li>
          состав семьи и&nbsp;сведения о&nbsp;близких родственниках (в&nbsp;том числе бывших), ФИО детей,
          их&nbsp;возраст и&nbsp;дата рождения, данные документа, удостоверяющего личность (данные паспорта: серия,
          номер, когда и&nbsp;каким органом выдан, код подразделения);
        </li>
        <li>адрес электронной почты, номер контактного телефона или сведения о других способах связи,</li>
        <li>
          сведения о&nbsp;воинском учете и&nbsp;реквизиты документов воинского учета, в&nbsp;том числе сведения
          об&nbsp;участии в&nbsp;боевых действиях, в&nbsp;специальной военной операции, а&nbsp;также сведения членов
          семей участников специальной военной операции (данные из удостоверений и&nbsp;справок, а&nbsp;также их&nbsp;копии);
        </li>
        <li>
          сведения об&nbsp;образовании, в&nbsp;том числе о&nbsp;послевузовском профессиональном образовании
          (наименование и&nbsp;год окончания образовательного учреждения, наименование и&nbsp;реквизиты документа
          об&nbsp;образовании, квалификация, специальность по&nbsp;документу об&nbsp;образовании), сведения
          об&nbsp;ученой степени,
        </li>
        <li>сведения об&nbsp;участии в&nbsp;учредительской/предпринимательской деятельности;</li>
        <li>сведения о&nbsp;наличии водительских прав;</li>
        <li>сведения о&nbsp;наличии личного автомобиля;</li>
        <li>сведения о&nbsp;трудовой деятельности;</li>
        <li>
          данные рабочей визы (серия и&nbsp;номер документа, фамилия, имя, национальность, дата выезда, дата окончания
          пребывания, количество дней пребывания, номер паспорта, дата рождения, пол, номер приглашения, цель поездки,
          принимающая организация, многократная/однократная), сведения, подтверждающие право нахождения
          на&nbsp;территории&nbsp;РФ, содержащиеся в&nbsp;виде на&nbsp;жительство/разрешении на временно
          проживание/визе/миграционной карте;
        </li>
        <li>
          сведения о&nbsp;предпринимательской деятельности (регистрация в&nbsp;качестве ИП / участника&nbsp;/
          единоличного исполнительного органа&nbsp;/ участника коллегиального органа, управляющего юридическим лицом)
        </li>
        <li>
          реквизиты страхового свидетельства государственного пенсионного страхования; идентификационный номер
          налогоплательщика; реквизиты страхового медицинского полиса обязательного медицинского страхования;
        </li>
        <li>владение иностранными языками;</li>
        <li>
          сведения, предоставленные Соискателем дополнительно (указанные в резюме, анкетах, в&nbsp;процессе
          собеседования).
        </li>
      </ul>
      <p>
        <strong>Перечень действий с&nbsp;ПДн:</strong> получение, сбор, запись, систематизация, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), блокирование,
        удаление, уничтожение.
      </p>
      <p>
        <strong>Способы обработки ПДн</strong>: обработка с&nbsp;использованием средств автоматизации и&nbsp;без
        использования средств автоматизации, а&nbsp;также смешанная обработка.
      </p>
      <p>Настоящим соглашаюсь на&nbsp;проверку предоставленных мной персональных данных и&nbsp;сведений.</p>
      <p>
        <strong>Лица, осуществляющие обработку по&nbsp;поручению</strong> для достижения указанной цели:
      </p>
      <ul className={styles.list}>
        <li>
          ООО &laquo;Скиллаз&raquo;, ОГРН: 1177746032276, адрес: 143026, г. Москва, территория Сколково Инновационного
          Центра, улица Нобеля, дом 5, этаж&nbsp;1, помещение&nbsp;1, рабочее место 11;
        </li>
        <li>
          ООО &laquo;ИТ&nbsp;ИКС 5&nbsp;Технологии&raquo;, расположенному по&nbsp;адресу: 420500, Респ. Татарстан,
          Верхнеуслонский р-н, г. Иннополис, ул. Университетская, д.&nbsp;7, офис 403;
        </li>
      </ul>
      <p>
        <strong>Третьи лица</strong>, которым Компания может передавать ПДн (предоставлять доступ к&nbsp;ним) для
        достижения указанной цели:
      </p>
      <ul className={styles.list}>
        <li>
          совокупность юридических лиц, входящих с&nbsp;ПАО &laquo;Корпоративный центр ИКС&nbsp;5&raquo; в&nbsp;одну
          группу лиц по&nbsp;смыслу&nbsp;ст.&nbsp;9&nbsp;Федерального закона от&nbsp;26.07.2006 &#8470;&nbsp;135-ФЗ
          &laquo;О&nbsp;защите конкуренции&raquo;, в&nbsp;том числе юридических лиц, функции единоличных исполнительных
          органов которых переданы ПАО &quot;Корпоративный центр ИКС&quot;5&Prime; по соответствующим договорам
          (далее&nbsp;&mdash; Группа Х5).
        </li>
      </ul>
      <p>
        <strong>Источники получения ПДн:</strong> Компания может получать ПДн от&nbsp;Соискателя; от&nbsp;лиц,
        осуществляющих обработку ПДн по&nbsp;поручению Компании (при наличии); от&nbsp;компаний Группы Х5, а&nbsp;также
        от&nbsp;государственных и&nbsp;муниципальных органов.
      </p>
      <p>
        <strong>Срок действия согласия:</strong> Согласие действует в&nbsp;течение&nbsp;
        <strong>5&nbsp;лет</strong> с момента последнего прохождения Соискателем собеседования в&nbsp;любом юридическом
        лице, входящем в&nbsp;Группу Х5.
      </p>
      <p>
        <strong>Отзыв согласия:</strong> Соискатель вправе отозвать настоящее согласие полностью или частично одним
        из&nbsp;следующих способов:
      </p>
      <ul className={styles.list}>
        <li>
          отправив сообщение на&nbsp;электронную почту{' '}
          <a className={styles.mailLink} href="mailto:pdn@x5.ru" target="_blank" rel="noopener noreferrer">
            pdn@x5.ru
          </a>{' '}
          с указанием в&nbsp;теме электронного письма &laquo;Отзыв согласия на&nbsp;обработку персональных данных&raquo;
          и&nbsp;прикреплением скан-копии подписанного заявления об отзыве согласия;
        </li>
        <li>
          направив письменный отзыв по&nbsp;адресу Компании: 109029, город Москва, Средняя Калитниковская ул,
          д.&nbsp;28, стр.&nbsp;4, этаж/пом/ком 1/XII/№36.
        </li>
      </ul>
    </>
  );
};

const PerekrestokAgreement = () => {
  return <>
      <p>
          Я&nbsp;соглашаюсь с&nbsp;обработкой моих персональных данных (далее&nbsp;&mdash; ПДн) АО&nbsp;&laquo;Торговый
          дом &laquo;ПЕРЕКРЕСТОК&raquo;, адрес: 109029, г. Москва, ул. Средняя Калитниковская, д.&nbsp;28, стр.&nbsp;4;
          (далее&nbsp;&mdash; &laquo;
          <strong>Компания</strong>&raquo;), на&nbsp;условиях, установленных в&nbsp;настоящем согласии.
        </p>

      <p>
        <strong>Цель обработки персональных данных:</strong>
      </p>
      <p>
        оценка и&nbsp;рассмотрение моей кандидатуры (далее также&nbsp;&mdash; Соискатель) для замещения вакантной
        должности и&nbsp;принятия решения о&nbsp;трудоустройстве Соискателя в&nbsp;Компанию (включая проведение
        комплаенс-контроля и осуществление процесса противодействия коррупции, а&nbsp;также формирование кадрового
        резерва Оператора и&nbsp;группы Х5&nbsp;для замещения вакантных должностей).
      </p>
      <p>
        <strong>Категории обрабатываемых ПДн:</strong> для достижения указанной цели осуществляется обработка следующих
        ПДн:
      </p>
      <ul className={styles.list}>
        <li>
          ФИО (в&nbsp;том числе предыдущие фамилии, имена&nbsp;и (или) отчества, в&nbsp;случае их&nbsp;изменения),
          число, место и&nbsp;год рождения, место рождения, пол, информация о&nbsp;гражданстве, вид, серия, номер
          документа, удостоверяющего личность, наименование органа, выдавшего его, дата выдачи, адрес места жительства
          (адрес регистрации, фактического проживания);
        </li>
        <li>семейное положение, реквизиты свидетельства государственной регистрации актов гражданского состояния;</li>
        <li>
          состав семьи и&nbsp;сведения о&nbsp;близких родственниках (в&nbsp;том числе бывших), ФИО детей,
          их&nbsp;возраст и&nbsp;дата рождения, данные документа, удостоверяющего личность (данные паспорта: серия,
          номер, когда и&nbsp;каким органом выдан, код подразделения);
        </li>
        <li>адрес электронной почты, номер контактного телефона или сведения о других способах связи,</li>
        <li>сведения о&nbsp;воинском учете и&nbsp;реквизиты документов воинского учета,</li>
        <li>
          сведения об&nbsp;образовании, в&nbsp;том числе о&nbsp;послевузовском профессиональном образовании
          (наименование и&nbsp;год окончания образовательного учреждения, наименование и&nbsp;реквизиты документа
          об&nbsp;образовании, квалификация, специальность по&nbsp;документу об&nbsp;образовании), сведения
          об&nbsp;ученой степени,
        </li>
        <li>сведения об&nbsp;участии в&nbsp;учредительской/предпринимательской деятельности;</li>
        <li>сведения о&nbsp;наличии водительских прав;</li>
        <li>сведения о&nbsp;наличии личного автомобиля;</li>
        <li>сведения о&nbsp;трудовой деятельности;</li>
        <li>
          данные рабочей визы (серия и&nbsp;номер документа, фамилия, имя, национальность, дата выезда, дата окончания
          пребывания, количество дней пребывания, номер паспорта, дата рождения, пол, номер приглашения, цель поездки,
          принимающая организация, многократная/однократная), сведения, подтверждающие право нахождения
          на&nbsp;территории&nbsp;РФ, содержащиеся в&nbsp;виде на&nbsp;жительство/разрешении на временное
          проживание/визе/миграционной карте;
        </li>
        <li>
          сведения о&nbsp;предпринимательской деятельности (регистрация в&nbsp;качестве ИП / участника&nbsp;/
          единоличного исполнительного органа&nbsp;/ участника коллегиального органа, управляющего юридическим лицом)
        </li>
        <li>
          реквизиты страхового свидетельства государственного пенсионного страхования; идентификационный номер
          налогоплательщика; реквизиты страхового медицинского полиса обязательного медицинского страхования;
        </li>
        <li>владение иностранными языками;</li>
        <li>
          сведения, предоставленные Соискателем дополнительно (указанные в резюме, анкетах, в&nbsp;процессе
          собеседования).
        </li>
      </ul>
      <p>
        <strong>Перечень действий с&nbsp;ПДн:</strong> получение, сбор, запись, систематизация, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), блокирование,
        удаление, уничтожение.
      </p>
      <p>
        <strong>Способы обработки ПДн</strong>: обработка с&nbsp;использованием средств автоматизации и&nbsp;без
        использования средств автоматизации, а&nbsp;также смешанная обработка.
      </p>
      <p>Настоящим соглашаюсь на&nbsp;проверку предоставленных мной персональных данных и&nbsp;сведений.</p>
      <p>
        <strong>Лица, осуществляющие обработку по&nbsp;поручению</strong> для достижения указанной цели:
      </p>
      <ul className={styles.list}>
        <li>
          ООО &laquo;Скиллаз&raquo;, ОГРН: 1177746032276, адрес: 143026, г. Москва, территория Сколково Инновационного
          Центра, улица Нобеля, дом 5, этаж&nbsp;1, помещение&nbsp;1, рабочее место 11;
        </li>
        <li>
          ООО &laquo;ИТ&nbsp;ИКС 5&nbsp;Технологии&raquo;, расположенному по&nbsp;адресу: 420500, Респ. Татарстан,
          Верхнеуслонский р-н, г. Иннополис, ул. Университетская, д.&nbsp;7, офис 403;
        </li>
      </ul>
      <p>
        <strong>Третьи лица</strong>, которым Компания может передавать ПДн (предоставлять доступ к&nbsp;ним) для
        достижения указанной цели:
      </p>
      <ul className={styles.list}>
        <li>
          совокупность юридических лиц, входящих с&nbsp;ПАО &laquo;Корпоративный центр ИКС&nbsp;5&raquo; в&nbsp;одну
          группу лиц по&nbsp;смыслу&nbsp;ст.&nbsp;9&nbsp;Федерального закона от&nbsp;26.07.2006 &#8470;&nbsp;135-ФЗ
          &laquo;О&nbsp;защите конкуренции&raquo;, в&nbsp;том числе юридических лиц, функции единоличных исполнительных
          органов которых переданы ПАО &quot;Корпоративный центр ИКС&quot;5&Prime; по соответствующим договорам
          (далее&nbsp;&mdash; Группа Х5).
        </li>
      </ul>
      <p>
        <strong>Источники получения ПДн:</strong> Компания может получать ПДн от&nbsp;Соискателя; от&nbsp;лиц,
        осуществляющих обработку ПДн по&nbsp;поручению Компании (при наличии); от&nbsp;компаний Группы Х5, а&nbsp;также
        от&nbsp;государственных и&nbsp;муниципальных органов.
      </p>
      <p>
        <strong>Срок действия согласия:</strong> Согласие действует в&nbsp;течение&nbsp;
        <strong>5&nbsp;лет</strong>с момента последнего прохождения Соискателем собеседования в&nbsp;любом юридическом
        лице, входящем в&nbsp;Группу Х5.
      </p>
      <p>
        <strong>Отзыв согласия:</strong> Соискатель вправе отозвать настоящее согласие полностью или частично одним
        из&nbsp;следующих способов:
      </p>
      <ul className={styles.list}>
        <li>предоставив письменный отзыв согласия лично в&nbsp;Компанию;</li>
        <li>
          отправив сообщение на&nbsp;электронную почту{' '}
          <a className={styles.mailLink} href="mailto:pdn@x5.ru" target="_blank" rel="noopener noreferrer">
            pdn@x5.ru
          </a>{' '}
          с указанием в&nbsp;теме электронного письма &laquo;Отзыв согласия на&nbsp;обработку персональных данных&raquo;
          и&nbsp;прикреплением скан-копии подписанного заявления об отзыве согласия;
        </li>
        <li>
          направив письменный отзыв по&nbsp;адресу Компании: 109029, г. Москва, ул. Средняя Калитниковская, д.&nbsp;28,
          стр.&nbsp;4.
        </li>
      </ul></>;
};

export const Agreement = ({ retailer }: AgreementProps) => {
  return (
    <div className={styles.agreement}>
      <h5 className={styles.header}>СОГЛАСИЕ СОИСКАТЕЛЯ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h5>
      {retailer === 'pyaterochka' && (
        <X5Agreement/>
      )}
      {retailer === 'perekrestok' && (
        <PerekrestokAgreement/>
      )}
      {retailer === 'chizhik' && (<ChizhikAgreement/>)}
    </div>
  );
};
